import { FC, memo } from 'react';
import { Modal } from 'shared/ui/Modal';
import { Form } from 'features/Form';
import { FeedbackRequestDto } from 'shared/api';
import { FEEDBACK_FORM_FIELDS } from '../../constants/feedbackConstants';

interface FeedbackFormProps {
  isOpen: boolean;
  editingFeedback: FeedbackRequestDto | null;
  isEditing: boolean;
  onSubmit: (data: FeedbackRequestDto) => void;
  onCancel: () => void;
}

export const FeedbackForm: FC<FeedbackFormProps> = memo(({
  isOpen,
  editingFeedback,
  isEditing,
  onSubmit,
  onCancel,
}) => (
  <Modal
    title={isEditing ? 'Редактировать отзыв' : 'Создать отзыв'}
    open={isOpen}
    onCancel={onCancel}
    footer={null}
    width={800}
  >
    <Form
      fields={FEEDBACK_FORM_FIELDS}
      initialValues={editingFeedback || {}}
      onSubmit={onSubmit}
    />
  </Modal>
));

FeedbackForm.displayName = 'FeedbackForm';
